import { render, staticRenderFns } from "./category-list-group-item.vue?vue&type=template&id=90e9a796&"
import script from "./category-list-group-item.vue.ts?vue&type=script&lang=ts&"
export * from "./category-list-group-item.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports